import React, { useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
// ShareIcon
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkIcon from "@material-ui/icons/Link";

import { useRouter } from "next/router";
import { BasicAlert } from "components/Alert";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { initKakao, shareKakao } from "components/KakaoShare";

import MaterialModal from "components/modal/MaterialModal";

const ShareModal = ({ open, handleClose, path, title, description }) => {
  const router = useRouter();

  // const basicUrl = "aiso-api.du.r.appspot.com";
  const basicUrl = "aiso.ai";
  const linkUrl = path ? basicUrl.concat(path) : basicUrl.concat(router.asPath);
  useEffect(() => {
    initKakao();
  }, []);

  const handleKakaoShare = async () => {
    const sendLinkUrl = `https://${linkUrl}`;
    shareKakao(sendLinkUrl, title, description);
  };

  return (
    <MaterialModal open={open} closeModal={handleClose}>
      <div className="popup-content max-w-xl">
        <div className="popup-header">
          <div className="h-full">
            <IconButton aria-label="close" className="w-15 h-15" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        <div className="popup-body flex flex-col justify-center items-center">
          <h5 className="text-333 font-gmarket-medium text-2xl font-bold mb-4">Share</h5>
          <div className="row w-full">
            <div className="col-6 col-sm-3">
              <div
                className="share-card p-3"
                onClick={() => {
                  handleClose();
                  // const linkUrl = `aiso-api.du.r.appspot.com${router.asPath}`;
                  window.open("https://www.facebook.com/sharer.php?u=" + encodeURIComponent(linkUrl));
                }}
              >
                <div className="face-share-icon">
                  <FacebookIcon fontSize="large" />
                </div>
                <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">facebook</p>
              </div>
            </div>
            <div className="col-6 col-sm-3">
              <div className="share-card p-3" onClick={handleKakaoShare}>
                <div className="kakao-share-icon">
                  <div style={{ width: "40px", height: "40px" }}>
                    <img className="p-1" src="/images/market/kakaotalk.svg" alt="" />
                  </div>
                </div>
                <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">Kakao Talk</p>
              </div>
            </div>
            <div className="col-6 col-sm-3">
              <div
                className="share-card p-3"
                onClick={() => {
                  handleClose();
                  window.open("https://twitter.com/intent/tweet/?url=" + encodeURIComponent(linkUrl));
                }}
              >
                <div className="twitter-share-icon">
                  <TwitterIcon fontSize="large" />
                </div>
                <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">Twitter</p>
              </div>
            </div>
            <div className="col-6 col-sm-3">
              <CopyToClipboard
                text={`https://${linkUrl}`}
                onCopy={() => {
                  BasicAlert("클립보드에 복사되었습니다.");
                  handleClose();
                }}
              >
                <div className="share-card p-3">
                  <div className="twitter-share-icon">
                    <LinkIcon fontSize="large" />
                  </div>
                  <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">Copy Link</p>
                </div>
              </CopyToClipboard>
            </div>
          </div>
        </div>
        <div className="popup-footer"></div>
      </div>
    </MaterialModal>
  );
};

export default ShareModal;
